export default {
  error: (message: string | { [key: string]: unknown }) => {
    // eslint-disable-next-line no-console
    console.error(message);
  },
  info: (message: string | { [key: string]: unknown }) => {
    // eslint-disable-next-line no-console
    console.info(message);
  },
  warning: (message: string | { [key: string]: unknown }) => {
    // eslint-disable-next-line no-console
    console.warn(message);
  },
  debug: (message: string | { [key: string]: unknown }) => {
    // eslint-disable-next-line no-console
    console.debug(message);
  },
};
